// Google Analytics (GA4) sayfa goruntuleme takibi.
//
// Uygulama bir SPA oldugu icin rota degisiminde tarayici yeni bir sayfa
// yuklemiyor; page_view'i elle gondermek gerekiyor. index.html'de
// send_page_view: false verildi, yani ILK page_view de buradan gidiyor.
//
// Neden componentDidMount/DidUpdate'ten cagriliyor: her sayfa kendi
// document.title'ini componentDidMount'ta set ediyor ve React'te cocuk
// bilesenler ebeveynden once mount oluyor. Boylece page_view gonderildiginde
// baslik guncel oluyor. (GA'nin kendi gecmis dinleyicisi pushState aninda
// okudugu icin bir onceki sayfanin basligini gonderiyordu.)

import { isIndexableHost } from "./seo";

const MEASUREMENT_ID = "G-VZ2NMCCHR5";

export const trackPageView = () => {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (typeof window.gtag !== "function") return;

  // Test/staging/preview host'larinda canli mulku kirletme.
  if (!isIndexableHost(window.location.hostname)) return;

  window.gtag("event", "page_view", {
    send_to: MEASUREMENT_ID,
    page_title: document.title,
    page_location: window.location.href,
    page_path: window.location.pathname + window.location.search
  });
};
